import { createI18n } from 'vue-i18n';
import { reactive } from 'vue';

// Импортируйте ваши файлы локализации
import messages from '@/locales/index.js';


// Определение предпочитаемого языка браузера или использование сохраненного в localStorage
const browserLocale = 'ko';
const defaultLocale = 'ko';


// Сохранение предпочитаемого языка в localStorage
if (typeof window !== 'undefined' && window.localStorage && defaultLocale) {
    localStorage.setItem('preferred_locale', defaultLocale);
}

// Создание реактивного свойства для текущей локали
const locale = reactive({
    current: defaultLocale,
});

// Функция для обновления текущей локали и сохранения в localStorage
function changeLocale(newLocale) {
    if (newLocale in messages) {
        locale.current = newLocale;
        if (typeof window !== 'undefined' && window.localStorage) {
            localStorage.setItem('preferred_locale', newLocale);
        }
    } else {
        console.warn(`Locale ${newLocale} is not available.`);
    }
}

// Установка локали по умолчанию и fallback локали
const i18n = createI18n({
    legacy: false, // Отключаем легаси-режим
    locale: locale.current,
    fallbackLocale: 'ko',
    messages,
});

export { i18n, locale, changeLocale };
